"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var staticAdapter = function staticAdapter(pathname) {
  return {
    pathname: pathname,
    listen: function listen() {
      return function () {};
    }
  };
};

var _default = staticAdapter;
exports.default = _default;
module.exports = exports.default;